module.exports = __webpack_public_path__ + "images/emoji/hatched_chick.eea55c74abcc0557d53f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hatched_chick.png
// module id = V5ws
// module chunks = 2